<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" row-key="id"
        ref="crud" @search-change="searchChange" @refresh-change="refreshChange(page)" @expand-change="expandChange"
        @search-reset="searchClear" @row-save="handleSave" @row-update="handleUpdate"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="search">
          <el-form-item label="工程项目" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="serviceCategoryId" placeholder="请选择工程项目" width="200" clearable
                @change="chooseProjectItem" value-key="id">
                <el-option v-for="item in serviceCategoryIds" :key="item.id" :label="item.name"
                  :value="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" size="small" icon="el-icon-plus" plain
            @click.stop="handleAdd(scope.row, scope.index)">新增</el-button>
          <el-button type="warning" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_PROJECTSERVICE"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_PROJECTSERVICE"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除</el-button>
          <el-button type="success" icon="el-icon-download" size="small" plain
            @click.stop="downloadExcel">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <div style="display: flex">
            <el-button type="info" size="small" plain @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
            <el-button type="success" size="small" plain @click.stop="handleView(scope.row, scope.index)">查看</el-button>
            <el-button type="primary" size="small" v-if="tableOption.expandRowKeys[0] == scope.row.id" plain
              @click.stop="handleExpend(scope.row, '收起')">收起</el-button>
            <el-button type="primary" size="small" v-else plain
              @click.stop="handleExpend(scope.row, '展开')">展开</el-button>
          </div>
        </template>
        <template slot-scope="props" slot="expand">
          <div>
            <!-- {{props.row.childList}} -->
            <el-table :data="props.row.childList" border style="margin:0px 50px; width: 95%" size="mini">
              <el-table-column property="serviceItemName" label="服务项目" align="center">
              </el-table-column>
              <el-table-column property="realName" label="服务工程师" align="center">
              </el-table-column>
              <el-table-column property="mobile" label="联系电话" align="center"></el-table-column>
              <el-table-column property="serviceTime" label="工程开始时间" align="center" width="200"
                :formatter="formatterServiceTime">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.isEdit">
                      <el-date-picker v-model="scope.row.serviceTime" disabled type="datetime" value-format="timestamp"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </div>
                    <div v-else>
                      <el-date-picker v-model="scope.row.serviceTime" value-format="timestamp" type="datetime"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="endTime" label="工程结束时间" width="200" align="center">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.isEdit">
                      <el-date-picker v-model="scope.row.endTime" disabled type="datetime" value-format="timestamp"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </div>
                    <div v-else>
                      <el-date-picker v-model="scope.row.endTime" type="datetime" value-format="timestamp"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="actualEndTime" label="工程实际结束时间" :formatter="formatterActualEndTime" width="200"
                align="center">
              </el-table-column>
              <el-table-column property="payMoney" label="服务费用" :formatter="formatterPayMoney" align="center">
              </el-table-column>
              <el-table-column property="payStatus" label="服务状态" :formatter="formatterPayStatus" align="center">
              </el-table-column>
              <el-table-column property="asd" label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button style="color: #909399" type="text" size="small" icon="el-icon-edit" plain
                      v-if="scope.row.isEdit" @click.stop="handleExpandEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button style="color: #409EFF" type="text" size="small" plain icon="el-icon-check"
                      v-if="!scope.row.isEdit" @click.stop="handleSingleSave(scope.$index, scope.row)">保存</el-button>
                    <el-button style="color: #409EFF" type="text" size="small" plain icon="el-icon-check" v-if="scope.row.status == 'TO_BE_THE_FINAL' &&
                      props.row.isAuditor == 'YES'
                    " @click.stop="passAudit(scope.row, scope.$index)">通过</el-button>
                    <el-button style="color: #F56C6C" type="text" size="small" plainicon="el-icon-close" v-if="
                      scope.row.status == 'TO_BE_THE_FINAL' &&
                      props.row.isAuditor == 'YES'
                    " @click.stop="rejectAudit(scope.row, scope.index)">拒绝</el-button>
                    <el-button style="color: #67C23A" type="text" size="small" plain icon="el-icon-view"
                      @click.stop="serviceListing(scope.row)">查看</el-button>
                    <el-button style="color: #67C23A" type="text" size="small" plain v-if="
                      scope.row.status == 'WAIT_PAY' &&
                      props.row.isPay == 'YES'
                    " @click.stop="openPay(scope.row)">支付</el-button>
                  </div>
                </template>
              </el-table-column>
              <!--   <el-table-column
                property="endTime"
                label="工程结束时间"
                :formatter="formatterEndTime"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="realEndTime"
                label="工程实际结束时间"
                :formatter="formatterEndTime"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="totalMoney"
                label="服务费用"
                align="center"
              ></el-table-column>

              <el-table-column
                property="status"
                label="服务状态"
                :formatter="transStatusName"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="option"
                label="操作"
                align="center"
              >
                <template slot-scope="scope">
                  <template v-for="dsrmsButton in dsrmsButtons">
                    <div :key="dsrmsButton.id">
                      <el-button
                        type="default"
                        icon="el-icon-check"
                        size="small"
                        plain
                        v-if="handleDsrms(scope.row, dsrmsButton)"
                        @click.stop="statusOption(dsrmsButton.step, scope.row)"
                      >{{ dsrmsButton.name }}</el-button>
                    </div>
                  </template>
                  <el-button
                    type="success"
                    icon="el-icon-view"
                    size="small"
                    plain
                    @click.stop="openOptionHistory(scope.row)"
                  >操作历史</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </template>
      </avue-crud>
      <template>
        <el-dialog :visible.sync="rechargeDialog" title="充值" center width="1000px">
          <div class="remittance" style="
              font-size: 14px;
              display: flex;
              flex-flow: column nowrap;
              align-items: flex-start;
              margin-left: 205px;
            ">
            <div class="recharge">
              <span style="width: 130px; text-align: left">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="number" placeholder="请输入充值金额" v-model="rechargeMoney" style="width: 215px"></el-input>
            </div>
            <div style="display: flex; justify-content: flex-start">
              <span style="width: 130px; text-align: left">支付方式:</span>
              <div>
                <el-radio v-model="payRadio" label="OFFLINE_REMIT" @change="rechargeWayOFFLINE_REMIT">线下汇款</el-radio>
                <el-radio v-model="payRadio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width: 130px; text-align: left">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户名称" v-model="remittanceAccountName"
                style="width: 215px"></el-input>
              <i style="
                  font-style: normal;
                  display: inline;
                  font-size: 12px;
                  color: red;
                ">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width: 130px; text-align: left">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户" v-model="remittanceAccount" style="width: 215px"></el-input>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex; justify-content: flex-start">
              <span style="width: 130px; text-align: left">汇款银行:</span>
              <div>
                <el-select placeholder="请输入汇款银行" v-model="currBank" style="width: 215px">
                  <el-option v-for="item in remittanceBank" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'" style="margin-bottom: 40px">
              <span style="width: 130px; text-align: left">凭证:</span>
              <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1" :http-request="fnUploadremittanceImgs" :show-file-list="false">
                <div v-if="'' != remittanceImgs" class="el-upload el-upload--picture-img">
                  <img v-for="remittanceImg of remittanceImgs" :key="remittanceImg.value" :src="remittanceImg"
                    style="width: 200px" />
                </div>
                <div v-else class="el-upload el-upload--car-two">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">
                  请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb
                </div>
              </el-upload>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width: 130px; text-align: left">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width: 130px; text-align: left">账户号码:</span>
              4402209109100103208
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width: 130px; text-align: left">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width: 130px; text-align: left">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button round size="mini" @click="balancePayment">&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button round type="danger" size="mini"
              @click="rechargeDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>
      <template>
        <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="destroyThisPay">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog title="选择付款方式" center :visible.sync="dialogBalancePay" width="50%">
        <div style="display: flex; justify-content: space-around">
          <el-radio v-if="!noMoney" v-model="balancePayRadio" label="YE">账户余额({{ getBalance + "元" }})</el-radio>
          <el-radio v-if="noMoney" v-model="balancePayRadio" label="YE">
            账户余额(
            <span style="color: red">
              余额不足
              <a href="#" style="
                  color: #409eff;
                  margin-left: 3px;
                  text-decoration: underline;
                " @click="toPayMoney">去充值</a> </span>)
          </el-radio>
          <el-radio v-model="balancePayRadio" label="WX">微信支付</el-radio>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogBalancePay = false">取 消</el-button>
          <el-button type="primary" @click="listPay">确认支付</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  findByLabel,
  formatterTime,
  getStatusName,
  parseStatus,
} from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { projectServiceOption } from "@/const/work/projectServiceOption";
import {
  findEngineeringOrderList,
  findEngineeringOrderListDownloadExcel,
  findProject,
  delItem,
  editEngineeringOrder,
  passAudit,
  refusedAudit,
  findEngineeringProjectAll,
  balancePay,
  findEngineeringProjectId,
} from "@/api/work/projectService";
import {
  findBalance,
  addBalance,
  immediatePay,
} from "@/api/salesCloud/accountBalance";
import { Image } from "element-ui";
import oss from "ali-oss";
import md5 from "js-md5";
import VueQr from "vue-qr";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
export default {
  name: "projectService",
  data() {
    return {
      tableOption: projectServiceOption, //表格设置属性
      tableData: [], //表格的数据
      superiorIds: [],
      superiorId: {},
      categoryTypes: [],
      paymentTask: {},
      serviceCategoryId: {},
      serviceCategoryIds: [],
      serviceCategoryName: {},
      rechargeDialog: false,
      rechargeMoney: "",
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      fileList1: [],
      remittanceImgs: [],
      QRCodeDialog: false,
      config: {},
      dataDialog: false,
      showBottom: false,
      evaluateDialog: false,
      dialogBalancePay: false,
      noMoney: true,
      //余额支付
      balancePayRadio: "YE",
      tablePage: 1,
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      url:
        "http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/7de80e574b428d8e6bc68663e33e1f60,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      list: [],
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
    };
  },
  created() {
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
    findEngineeringProjectAll().then((res) => {
      let data = JSON.parse(res.data);
      this.serviceCategoryIds = data;
    });
    this.tableOption.expandRowKeys[0] = [];
    this.handleList();
  },
  watch: {},
  mounted() { },
  components: {
    VueQr,
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    chooseProjectItem() { },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e.id;
      findProject(params).then((res) => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
      });
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    toPayMoney() {
      console.log("充值");
      this.clean();
      this.rechargeDialog = true;
    },
    listPay() {
      console.log(this.balancePayRadio);
      if (this.balancePayRadio == "WX") {
        this.immediatePayment(this.payRow);
      } else {
        let obj = {};
        obj.id = this.payRow.id;
        balancePay(obj).then((res) => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success",
            });
            setTimeout(() => {
              this.handleList();
              console.log("延迟2s");
            }, 2000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error",
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
        });
      }
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    expandRow(row) {
      console.log(row);
    },
    handleSingleSave(index, row) {
      console.log(row, index);
      row.isEdit = !row.isEdit;
      let params = { startTime: row.serviceTime, endTime: row.endTime };
      editEngineeringOrder(row.id, params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    openPay(row) {
      console.log(row);
      this.payRow = row;
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.payMoney;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    passAudit(row, index) {
      console.log(row, index);
      this.$confirm(`是否确认通过?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {};
        params.id = row.id;
        passAudit(params).then((res) => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "通过成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        });
      });
    },
    rejectAudit(row, index) {
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = row.id;
          obj.refusedReason = value;
          refusedAudit(obj).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error",
          });
        });
    },
    handleExpandEdit(index, row) {
      console.log(row.serviceTime);
      console.log(row);
      row.isEdit = !row.isEdit;
    },
    handleExpend(row, index) {
      console.log(row, index);
      console.log(this);
      row.isExpend = !row.isExpend;
      if (index == "展开") {
        if (this.tableOption.expandRowKeys) {
          this.tableOption.expandRowKeys = [];
          this.tableOption.expandRowKeys.push(row.id);
        }
      } else {
        this.tableOption.expandRowKeys = [];
      }
    },
    expandChange(row, expendList) {
      if (expendList.length) {
        this.tableOption.expandRowKeys = [];
        if (row) {
          this.tableOption.expandRowKeys.push(row.id);
        }
      } else {
        this.tableOption.expandRowKeys = [];
      }
    },
    formatterServiceTime(row) {
      console.log(row);
      // if (null != row.serviceTime) {
      //   return formatterTime(row.serviceTime);
      // }
      // if (null != row.endTime) {
      //   return formatterTime(row.endTime);
      // }
      // if (null != row.endTime) {
      //   return formatterTime(row.endTime);
      // }
    },
    formatterActualEndTime(row) {
      // console.log(row);
      if (null != row.actualEndTime) {
        return formatterTime(row.actualEndTime);
      }
    },
    formatterPayMoney(row) {
      if (null != row.payMoney) {
        return row.payMoney;
      } else {
        return "-";
      }
    },
    formatterPayStatus(row) {
      // console.log(row);
      return parseStatus(DIC.WORK_ORDER_STATUS, row.status);
    },
    transStatusName(row) {
      return getStatusName(this.steppings, row.status);
    },
    changeImage(row) {
      console.log(row);
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        // let picArray = row.split(",");
        let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      this.list = str;
    },
    formmaterImages(row) {
      let arr = [];
      arr.push(row[0]);
      // if (this.list != null) {
      //   console.log(this.list);
      //   arr = this.list;
      // } else {
      //   console.log(this.list);
      //   arr.push(row[0]);
      // }
      return row;
    },

    formmaterImage(row) {
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        //let picArray = row.split(",");
        let picArray = row;
        // console.log("picArray"+picArray)
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    formmaterImageNew(row) {
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        // let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          if (picArray[i] != 'null') {
            str.push(picArray[i]);
          }

        }
      }
      return str;
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.rechargeMoney = "";
      this.paymentTask = {};
      this.remittanceAccountName = "";
      this.remittanceAccount = "";
      this.currBank = "";
    },
    searchClear() {
      this.currClassify = "";
      this.serviceCategoryId = {};
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        for (let i of data.rows) {
          for (let j of i.childList) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        for (let i of data.rows) {
          for (let j of i.childList) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      delete params.serviceCategoryId; //清除缓存
      console.log(params);
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        delete params.startTime;
        delete params.endTime;
      }
      if (this.serviceCategoryId.id != undefined) {
        params.serviceCategoryId = this.serviceCategoryId.id;
      }
      this.downloadData = params;
      console.log(params);
      findEngineeringOrderList(params).then((res) => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          for (let i of data.rows) {
            for (let j of i.childList) {
              j.isEdit = true;
              j.isExpend = true;
              // j.endTime = j.endTime + "";
              // j.serviceTime = j.serviceTime + "";
            }
          }
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size,
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findEngineeringOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        for (let i of data.rows) {
          for (let j of i.childList) {
            j.isEdit = true;
            j.isExpend = true;
            // j.endTime = j.endTime + "";
            // j.serviceTime = j.serviceTime + "";
          }
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增工程服务",
        value: "projectService/add",
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
      });
    },
    handleEdit(row, index) {
      console.log(row, index);
      let obj = {
        label: "编辑工程服务",
        value: "projectService/edit",
        query: { id: row.id, aname: row.name },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    handleView(row, index) {
      console.log(row, index);
      let obj = {
        label: "查看工程服务",
        value: "projectService/view",
        query: { id: row.id, aname: row.name },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findEngineeringOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        for (let i of data.rows) {
          if (i.childList) {
            for (let j of i.childList) {
              j.isEdit = true;
              j.isExpend = true;
              // j.endTime = j.endTime + "";
              // j.serviceTime = j.serviceTime + "";
            }
          }
        }
        this.tableData = data.rows;
        console.log(data, "data.rows的值11");
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map((item) => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delItem(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success",
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              this.dialogBalancePay = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error",
          });
        }
      } else {
        addBalance(params).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "充值成功",
                      type: "success",
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.dialogBalancePay = false;
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "充值成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.dialogBalancePay = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.rechargeDialog = false;
                          this.dialogBalancePay = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付失败",
                  type: "error",
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败",
              type: "error",
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      editTags(row).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success",
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          done();
        }
      });
    },
    downloadExcel() {
      let params = this.downloadData;
      findEngineeringOrderListDownloadExcel(params).then((res) => {
        window.open(res);
      });
    },
    serviceListing(row) {
      // 跳转到工单详情
      this.$router.push({
        name: "工程工单信息详情",
        path: "/work/projectService/workOrderInfo",
        query: { id: row.id }
      });
    },
  },
};
</script>

<style lang="scss">
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
